import { render, staticRenderFns } from "./GroupTeamEdit.vue?vue&type=template&id=106a6aad&scoped=true"
import script from "./GroupTeamEdit.vue?vue&type=script&lang=js"
export * from "./GroupTeamEdit.vue?vue&type=script&lang=js"
import style0 from "./GroupTeamEdit.vue?vue&type=style&index=0&id=106a6aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a6aad",
  null
  
)

export default component.exports